import type { VoidFunctionComponent } from 'react';

import { useQuery } from '../../../contexts/RouterContext';
import { type GenerateReportAction, GenerateReportButton } from '../components/GenerateReportButton';
import { useRemediationDownloadReport } from '../hooks/useRemediationDownloadReport';
import { DEFAULT_REMEDIATION_FORMAT, type ReportsV3QueryParams } from '../types';

/**
 * Remediation-specific generate button — download only (no public link, no email).
 * Reuses the shared GenerateReportButton presentational component.
 */
export const RemediationGenerateButton: VoidFunctionComponent = () => {
  const [query] = useQuery<ReportsV3QueryParams>();
  const reportFormat = query.format ?? DEFAULT_REMEDIATION_FORMAT;
  const { downloadReport } = useRemediationDownloadReport(reportFormat);

  const onItemClick = (action: GenerateReportAction) => {
    if (action === 'download') {
      downloadReport();
    }
  };

  return (
    <GenerateReportButton
      isLoading={false}
      shouldShowPublicLink={false}
      shouldShowDownload
      shouldShowEmail={false}
      onItemClick={onItemClick}
    />
  );
};
